import { TStateUpdateErrorDE } from '../../types';

export const parseErrorMessageFromPointerDE = (
  error: Error,
  isIncludedInCompanySearchUITest: boolean = false,
): TStateUpdateErrorDE => {
  const pointer =
    error?.message && JSON.parse(error.message)?.errors?.[0]?.source?.pointer;

  if (!pointer) {
    return 'other';
  }

  // Step 0 fields
  if (pointer.includes('email')) {
    return 'Wie lautet Ihre E-Mail-Adresse?';
  }

  // Company details fields
  if (
    pointer.includes('creditreform_id') ||
    pointer.includes('registered_company_name') ||
    pointer.includes('type') ||
    pointer.includes('registered_address')
  ) {
    return isIncludedInCompanySearchUITest ? 'Unternehmensuche' : 'Firmenname';
  }

  if (pointer.includes('trading_from_date')) {
    return isIncludedInCompanySearchUITest
      ? 'Gründungsdatum'
      : 'Wann wurde Ihre Firma gegründet?';
  }

  if (pointer.includes('website')) {
    return 'Webseite';
  }

  if (pointer.includes('last_12_months_turnover')) {
    return 'Umsatz der letzten 12 Monate';
  }

  // Personal details fields
  if (
    pointer.includes('title') ||
    pointer.includes('first_name') ||
    pointer.includes('last_name')
  ) {
    return 'Name';
  }

  if (pointer.includes('date_of_birth')) {
    return 'Geburtsdatum';
  }

  if (pointer.includes('phones')) {
    return 'Telefonnummer';
  }

  if (pointer.includes('street_line_1')) {
    return 'Straße';
  }

  if (pointer.includes('house_number')) {
    return 'Hausnummer';
  }

  if (pointer.includes('street_line_2')) {
    return 'Adresszusatz';
  }

  if (pointer.includes('postcode')) {
    return 'Postleitzahl';
  }

  if (pointer.includes('town')) {
    return 'Ort';
  }

  if (pointer.includes('privacy_policy')) {
    return 'Ich habe alle Geschäftsbedingungen gelesen und akzeptiert.';
  }

  return 'other';
};
